import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .wallace-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .wallace-columns {
      grid-column: 2 / 8;
      grid-row: 2;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: 0;
      width: 100%;
      color: var(--block-text-color, #222);
    }

    .column {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
      padding: calc(20rem / var(--default-rem-px-count)) 0;
      border-bottom: 1px solid #cccccc;
    }

    .column:last-child {
      border-bottom: none;
    }

    .column-content {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
      width: 100%;
    }

    /* Wallace's mobile frame (22838:14408) uses the desktop H3 24 / H3 18 Small
       pair, not the Mobile Fonts set, so the hierarchy is pinned here and the
       tokens take back over at 600px — both title tiers are 16/20 below that. */
    .header {
      font-size: calc(24rem / var(--default-rem-px-count));
      line-height: calc(30rem / var(--default-rem-px-count));
      letter-spacing: -0.72px;
    }

    .subheader {
      font-size: calc(18rem / var(--default-rem-px-count));
      line-height: calc(24rem / var(--default-rem-px-count));
      letter-spacing: -0.72px;
    }

    .sample-image {
      width: 100%;
      max-width: calc(258rem / var(--default-rem-px-count));
      padding: calc(20rem / var(--default-rem-px-count)) 0;
    }

    .sample-image img {
      width: 100%;
      height: auto;
      display: block;
    }

    .header-cta {
      max-width: calc(258rem / var(--default-rem-px-count));
      width: 100%;
    }

    .section-heading {
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      font-weight: var(--fw-medium);
      text-transform: uppercase;
      margin: 0;
    }

    .downloads-heading {
      margin-top: calc(20rem / var(--default-rem-px-count));
    }

    .row {
      display: flex;
      flex-direction: column;
    }

    .row-header {
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      font-weight: var(--fw-medium);
    }

    .row-body {
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
    }

    .description-body {
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
    }

    .downloads {
      display: flex;
      flex-direction: column;
      gap: calc(10rem / var(--default-rem-px-count));
    }

    .cta-stack {
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
      max-width: calc(285rem / var(--default-rem-px-count));
      width: 100%;
    }

    @media (min-width: 600px) {
      .header {
        font-size: var(--fs-title);
        line-height: var(--lh-title);
        letter-spacing: var(--ls-title);
      }

      .subheader {
        font-size: var(--fs-title-small);
        line-height: var(--lh-title-small);
        letter-spacing: var(--ls-title-small);
      }

      .wallace-columns {
        grid-column: 2 / 14;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: var(--between-column-padding);
      }

      .column:nth-child(1),
      .column:nth-child(2) {
        border-bottom: 1px solid #cccccc;
      }

      .column:nth-child(3),
      .column:nth-child(4) {
        border-bottom: none;
      }
    }

    @media (min-width: 1024px) {
      .wallace-columns {
        grid-template-columns: repeat(4, minmax(0, 1fr));
      }

      .column {
        border-bottom: none;
      }

      .column:nth-child(1),
      .column:nth-child(2) {
        border-bottom: none;
      }
    }
  `,
];
